import { useTranslation } from 'react-i18next';

export const useNotificationConfig = isUserAdmin => {
  const { t } = useTranslation('accountSettings');

  const config = {
    preferences: {
      items: [
        {
          name: 'receiveTextNotifications',
          label: t('notificationPreferences.textNotifications.airboSms.label'),
          description: t(
            'notificationPreferences.textNotifications.airboSms.description',
          ),
        },
        {
          name: 'receiveEmailNotifications',
          label: t(
            'notificationPreferences.emailNotifications.airboEmail.label',
          ),
          description: t(
            'notificationPreferences.emailNotifications.airboEmail.description',
          ),
        },
      ],
    },
    emailNotifications: {
      items: [
        // Admin-only notifications
        ...(isUserAdmin
          ? [
              {
                name: 'sendWeeklyActivityReport',
                label: t('notificationPreferences.weeklyActivity.label'),
                description: t(
                  'notificationPreferences.weeklyActivity.description',
                ),
              },
              {
                name: 'receivesCampaignFeedbackRecap',
                label: t(
                  'notificationPreferences.emailNotifications.campaignFeedbackRecap.label',
                ),
                description: t(
                  'notificationPreferences.emailNotifications.campaignFeedbackRecap.description',
                ),
              },
              {
                name: 'receivesPendingQuestionsNotifications',
                label: t(
                  'notificationPreferences.emailNotifications.pendingQuestions.label',
                ),
                description: t(
                  'notificationPreferences.emailNotifications.pendingQuestions.description',
                ),
              },
              {
                name: 'receivesExploreEmail',
                label: t('notificationPreferences.exploreDigest.label'),
                description: t(
                  'notificationPreferences.exploreDigest.description',
                ),
              },
            ]
          : []),
      ],
    },
  };

  return config;
};
